const Context = {
  // client objects
  theme: 'lite', // theme
  locale: 'en', // locale (context.session.locale, context.account.locale not used)
  ecid: Math.random().toString(36).substring(5),
  apiHost: null,
  filter: 'classic',

  // server objects
  session: null,
  account: null,
  permissions: null
}

export default Context
